export default __webpack_public_path__ + "static/entelligent-f28c3b608c1b76a37d8ed924783bae65.png";